export const queryKeys = {
  auth: {
    session: () => ['auth', 'session'] as const,
    currentUser: () => ['auth', 'current-user'] as const,
  },
  tenantSettings: {
    current: () => ['tenant-settings', 'current'] as const,
    customerView: (tenant: string) => ['tenant-settings', 'customer-view', tenant] as const,
  },
  tenants: {
    current: () => ['tenants', 'current'] as const,
  },
  advanceOptions: {
    current: () => ['advance-options', 'current'] as const,
  },
  assets: {
    list: (params: {
      page: number;
      pageSize: number;
      categoryId?: string;
      search?: string;
    }) => ['assets', 'list', params] as const,
    byId: (id: string) => ['assets', 'by-id', id] as const,
    customerViewAll: (tenant: string) => ['assets', 'customer-view', 'all', tenant] as const,
    availability: (id: string, startAt: string, endAt: string, excludeRentalId?: string) =>
      ['assets', 'availability', id, startAt, endAt, excludeRentalId ?? ''] as const,
  },
  assetCategories: {
    list: () => ['asset-categories', 'list'] as const,
    customerViewList: (tenant: string) => ['asset-categories', 'customer-view', tenant] as const,
  },
  assetPackages: {
    list: () => ['asset-packages', 'list'] as const,
    customerViewList: (tenant: string) => ['asset-packages', 'customer-view', tenant] as const,
    byId: (id: string) => ['asset-packages', 'by-id', id] as const,
  },
  assetUnits: {
    list: (assetTypeId: string) => ['asset-units', 'list', assetTypeId] as const,
  },

  inventoryItems: {
    list: (params: {
      page: number;
      pageSize: number;
      search?: string;
      lowStock?: boolean;
      expiringSoon?: boolean;
    }) => ['inventory-items', 'list', params] as const,
    infiniteList: (params: {
      pageSize: number;
      search?: string;
      lowStock?: boolean;
      expiringSoon?: boolean;
    }) => ['inventory-items', 'infinite', params] as const,
    byId: (id: string) => ['inventory-items', 'by-id', id] as const,
  },
  inventoryItemCategories: {
    list: () => ['inventory-item-categories', 'list'] as const,
  },
  stockUpdates: {
    list: (params: { page: number; pageSize: number; search?: string }) =>
      ['stock-updates', 'list', params] as const,
    byId: (id: string) => ['stock-updates', 'by-id', id] as const,
  },
  stockAdjustments: {
    list: (params: {
      page: number;
      pageSize: number;
      search?: string;
      inventoryItemId?: string;
    }) => ['stock-adjustments', 'list', params] as const,
    byInventoryItem: (
      inventoryItemId: string,
      params: { page: number; pageSize: number; search?: string },
    ) => ['stock-adjustments', 'by-inventory-item', inventoryItemId, params] as const,
  },
  customers: {
    list: (params: { page: number; pageSize: number; search?: string; status?: string }) =>
      ['customers', 'list', params] as const,
    infiniteList: (params: { pageSize: number; search?: string; status?: string }) =>
      ['customers', 'infinite', params] as const,
    byId: (id: string) => ['customers', 'by-id', id] as const,
    rentals: (id: string, params: { page: number; pageSize: number }) =>
      ['customers', 'rentals', id, params] as const,
    sales: (id: string, params: { page: number; pageSize: number }) =>
      ['customers', 'sales', id, params] as const,
    smsLogs: (
      id: string,
      params: {
        page: number;
        pageSize: number;
        providerStatus?: string;
        dateFrom?: string;
        dateTo?: string;
        search?: string;
      },
    ) => ['customers', 'sms-logs', id, params] as const,
  },
  sales: {
    list: (params: {
      page: number;
      pageSize: number;
      status?: string;
      customerId?: string;
      dateFrom?: string;
      dateTo?: string;
    }) => ['sales', 'list', params] as const,
    infiniteList: (params: {
      pageSize: number;
      status?: string;
      customerId?: string;
      dateFrom?: string;
      dateTo?: string;
    }) => ['sales', 'infinite', params] as const,
    byId: (id: string) => ['sales', 'by-id', id] as const,
    customerView: (id: string, tenantName: string) => ['sales', 'customer-view', id, tenantName] as const,
  },
  rentals: {
    list: (params: {
      page: number;
      pageSize: number;
      status?: string;
      dateFrom?: string;
      dateTo?: string;
      customerId?: string;
    }) => ['rentals', 'list', params] as const,
    byId: (id: string) => ['rentals', 'by-id', id] as const,
    customerView: (id: string, tenantName: string) => ['rentals', 'customer-view', id, tenantName] as const,
  },
  analytics: {
    overview: (date: string) => ['analytics', 'overview', date] as const,
    revenue: (period: string) => ['analytics', 'revenue', period] as const,
    revenueRange: (from: string, to: string) => ['analytics', 'revenue-range', from, to] as const,
    busyDays: (month: string) => ['analytics', 'busy-days', month] as const,
  },
  expenseCategories: {
    list: () => ['expense-categories', 'list'] as const,
  },
  expenses: {
    list: (params: {
      page: number;
      pageSize: number;
      search?: string;
      categoryGuid?: string;
      dateFrom?: string;
      dateTo?: string;
    }) => ['expenses', 'list', params] as const,
    byId: (id: string) => ['expenses', 'by-id', id] as const,
  },
  auditLogs: {
    list: (params: {
      page: number;
      pageSize: number;
      search?: string;
      after?: string;
      before?: string;
    }) => ['audit-logs', 'list', params] as const,
    infiniteList: (params: {
      pageSize: number;
      search?: string;
      after?: string;
      before?: string;
    }) => ['audit-logs', 'infinite', params] as const,
  },
};

